import { render, staticRenderFns } from "./zheliban.vue?vue&type=template&id=bb249312&"
import script from "./zheliban.vue?vue&type=script&lang=js&"
export * from "./zheliban.vue?vue&type=script&lang=js&"
import style0 from "./zheliban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports